// The runtime's own strings (overlays, preview toasts). Module strings live in each module.
import { defineMessages } from '@frame/sdk/tv';

export const messages = defineMessages({
  en: {
    pendingTitle: 'This TV is waiting for approval',
    pendingText: 'Approve it on the Devices page of the admin panel.',
    unreachable: 'Can’t reach the server…',
    loading: 'Loading…',
    offline: 'No connection to the server',
    unknownWidget: (type: string) => `Unknown widget: ${type}`,
    previewLaunch: (app: string) => `(preview) would open: ${app}`,
    previewName: 'Panel preview',
    browserName: 'Browser',
    noResponse: 'The server didn’t respond',
    // Phone remote errors (shown on the phone).
    remoteTileGone: 'That tile is no longer on the screen',
    remoteUnknownKey: (key: string) => `Unknown key: ${key}`,
    remoteSamsungFailed:
      'Couldn’t send the key while the TV is in another app (the TV’s remote-control service didn’t allow it). Use Home to go back to the launcher.',
  },
  tr: {
    pendingTitle: 'Bu TV onay bekliyor',
    pendingText: 'Yönetim panelinde Cihazlar sayfasından onaylayın.',
    unreachable: 'Sunucuya ulaşılamıyor…',
    loading: 'Yükleniyor…',
    offline: 'Sunucu bağlantısı yok',
    unknownWidget: (type: string) => `Bilinmeyen widget: ${type}`,
    previewLaunch: (app: string) => `(önizleme) açılacaktı: ${app}`,
    previewName: 'Panel önizlemesi',
    browserName: 'Tarayıcı',
    noResponse: 'Sunucu cevap vermedi',
    remoteTileGone: 'Bu kutu artık ekranda yok',
    remoteUnknownKey: (key: string) => `Bilinmeyen tuş: ${key}`,
    remoteSamsungFailed:
      'TV başka bir uygulamadayken tuş gönderilemedi (TV’nin kumanda servisi izin vermedi). Ana ekran ile launcher’a dönebilirsin.',
  },
});
